<template>
    <cic-popup
        :title="item.ruleId ? 'Edit Retention Rule' : 'New Retention Rule'"
        :saveable="editing"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <div class="item-form">
            <ul>
                <li class="form-label-first">
                    {{ $t('Rule Name') }}
                </li>
                <li>
                    <cic-textbox
                        id="rule_name"
                        :enabled="editing"
                        :value="item.name"
                        :maxlength="256"
                        @input="(val) => updateFieldValue('name', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Object Type') }}
                </li>
                <li>
                    <cic-select
                        id="rule_object_type"
                        :enabled="editing"
                        :value="item.objectType"
                        :options="[
                            { value: 0, label: $t('Outbound presentation CLI') },
                            { value: 1, label: $t('ACCESS_TYPE_1') },
                            { value: 2, label: $t('Export Status') },
                        ]"
                        @input="(val) => updateFieldValue('objectType', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Object Values') }}
                </li>
                <li>
                    <CicCsvImport
                        v-if="editing"
                        :help-text="$t('Object value imports do not remove any existing object values')"
                        input-id="rule_object_import"
                        @change="
                            (val) =>
                                updateFieldValue(
                                    'objectValues',
                                    item.objectValues.concat(val.filter((obj) => !item.objectValues.includes(obj))),
                                )
                        "
                    />
                    <table id="rule_object_values">
                        <tbody>
                            <tr v-for="(objectValue, index) in item.objectValues">
                                <td>
                                    <cic-textbox
                                        :enabled="editing"
                                        :value="objectValue"
                                        :maxlength="256"
                                        @input="(val) => updateObjectValue(index, val)"
                                    />
                                </td>
                                <td v-if="editing">
                                    <icon-button icon="remove-icon" @click="removeObjectValue(index)" />
                                </td>
                            </tr>
                            <tr v-if="editing">
                                <td></td>
                                <td><icon-button icon="add-icon" @click="addObjectValue" /></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <li class="form-label">
                    {{ $t('RETENTION_PERIOD') }}
                </li>
                <li>
                    <cic-select
                        id="rule_period"
                        :enabled="editing"
                        :value="item.periodId"
                        :options="periods.map((x) => ({ value: x.periodId, label: x.name }))"
                        @input="(val) => updateFieldValue('periodId', val)"
                    />
                </li>
            </ul>
        </div>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import IconButton from '@/components/controls/IconButton';
    import { CicCsvImport, CicTextbox } from '@/components/inputs';
    import CicSelect from '@/components/inputs/CicSelect';

    export default {
        name: 'EditRetentionRule',
        components: {
            CicCsvImport,
            IconButton,
            CicPopup,
            CicSelect,
            CicTextbox,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            periods: {
                type: Array,
                required: true,
            },
        },
        emits: ['blur', 'input', 'updateFieldValue'],
        data() {
            return {
                editing: false,
            };
        },
        created() {
            this.editing = !this.item.ruleId || this.$store.hasRight('EDIT_RETENTION_RULES');
        },
        methods: {
            addObjectValue() {
                const values = [...this.item.objectValues];
                values.push('');
                this.updateFieldValue('objectValues', values);
            },
            removeObjectValue(index) {
                const values = [...this.item.objectValues];
                values.splice(index, 1);
                this.updateFieldValue('objectValues', values);
            },
            updateObjectValue(index, val) {
                const values = [...this.item.objectValues];
                values[index] = val;
                this.updateFieldValue('objectValues', values);
            },
            updateFieldValue(field, val) {
                this.$emit('updateFieldValue', field, val);
            },
        },
    };
</script>
